var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 98.8281C76.967 98.8281 98.8281 76.967 98.8281 50C98.8281 23.033 76.967 1.17188 50 1.17188C23.033 1.17188 1.17188 23.033 1.17188 50C1.17188 76.967 23.033 98.8281 50 98.8281Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M98.0869 58.5137L64.6557 25.0823H35.7778L33.0571 50.4729L34.3 52.0821L40.2627 58.0446H31.8502C31.8502 62.7088 33.5158 66.7284 36.3907 69.6729L63.6182 96.9012C81.3018 91.7754 94.85 76.9219 98.0869 58.5137Z",
    fill: "url(#paint0_linear_411_1338)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.744 41.7437C60.6506 41.7437 68.1498 48.4197 68.1498 57.9701C68.1498 67.8645 60.5658 74.9178 49.9432 74.9178C39.3295 74.9178 31.8502 67.9289 31.8502 58.0453H44.343C44.343 61.3523 46.6672 63.7182 49.9432 63.7182C53.1463 63.7182 55.4813 61.2674 55.4813 57.9691C55.4813 54.4711 53.0303 52.0828 49.459 52.0828H34.3L33.0571 50.4736L35.7778 25.083H64.6557V36.1854H45.8248L45.2112 41.7432H49.7424L49.744 41.7437Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_1338",
    x1: 32.0026,
    y1: 28.8575,
    x2: 86.0979,
    y2: 82.9528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyNumber);
export default __webpack_public_path__ + "static/media/key-number.343d19e265ad4ff229d5e98af5a1f89a.svg";
export { ForwardRef as ReactComponent };